var map = {
	"./S_SDG_Icons-01-01.jpg": 7923,
	"./S_SDG_Icons-01-02.jpg": 8212,
	"./S_SDG_Icons-01-03.jpg": 2545,
	"./S_SDG_Icons-01-04.jpg": 7938,
	"./S_SDG_Icons-01-05.jpg": 9647,
	"./S_SDG_Icons-01-06.jpg": 1648,
	"./S_SDG_Icons-01-07.jpg": 3869,
	"./S_SDG_Icons-01-08.jpg": 5214,
	"./S_SDG_Icons-01-09.jpg": 3259,
	"./S_SDG_Icons-01-10.jpg": 7741,
	"./S_SDG_Icons-01-11.jpg": 8512,
	"./S_SDG_Icons-01-12.jpg": 2127,
	"./S_SDG_Icons-01-13.jpg": 5461,
	"./S_SDG_Icons-01-14.jpg": 5857,
	"./S_SDG_Icons-01-15.jpg": 7812,
	"./S_SDG_Icons-01-16.jpg": 9443,
	"./S_SDG_Icons-01-17.jpg": 6278,
	"./S_SDG_Icons-01-18.jpg": 7317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5921;